<template>
    <component :is="component" :data="data" :tabIndex="tabIndex"/>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import base from '~/components/base.vue';
// eslint-disable-next-line import/no-unresolved
import desktop from '~/components/desktop/sport.vue';

export default {
    extends: base,
    components: {
        desktop
    },
    head() {
        return {};
    },
    data() {
        return {
            tabIndex: this.$getRoute(this.$route).path,
            data: {}
        };
    },
    methods: {
    },
    mounted() {
    },
    async asyncData({ app, store }) {
        if (store.state.user !== null) {
            const res = await app.$userApi.getWallet();
            if (res.status === 'OK') {
                return {
                    data: res.data
                };
            }
        }
    }
};

</script>
